import withLoader from "../../../components/layouts/WithLoader";
import { TextField } from "@material-ui/core";
import DiscountService from "../../../services/DiscountService";
import { useEffect, useState } from "react";
import WarehouseService from "../../../services/WarehouseService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import UtilsFormule from "../../../utils/UtilsFormule";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { Alert } from "@material-ui/lab";
import { Snackbar } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import toastr from "toastr";
const styles = {
  container: (base) => ({
    ...base,
    flex: 1,
  }),
};
const UpdateDeclencheur = () => {
  const navigate = useNavigate();

  const [warehouses, setWarehouses] = useState([]);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [availableDeclencheurs, setAvailableDeclencheurs] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const animatedComponents = makeAnimated();
  const [selectedOptionWarehouse, setSelectedOptionWarehouse] = useState(null);
  const [warehouseSelectPlaceHolder, setWarehouseSelectPlaceHolder] =
    useState(null);
  const [listWarehouseId, setListWarehouseId] = useState([]);
  const [choosenWarehouse, setChoosenWarehouse] = useState(false);
  const [allWarehouse, setAllWarehouse] = useState([{}]);
  const [startDate, setStartDate] = useState("any");
  const [endDate, setEndDate] = useState("any");
  const [allDiscounts, setAllDiscounts] = useState([]);
  const [choosenRulesWarehouses, setChoosenRulesWarehouses] = useState(0);
  const [ordreProduct, setOrdreProduct] = useState(1);
  const [selectedOptionDiscount, setSelectedOptionDiscount] = useState(null);
  const [discountSelectPlaceHolder, setDiscountSelectPlaceHolder] =
    useState(null);
  const [discountId, setDiscountId] = useState(0);
  const [discountLabel, setDiscountLabel] = useState("");
  const [extrats, setExtrats] = useState([]);
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [openDisableDiscount, setOpenDisableDiscount] = useState(false);
  const handleCloseDisableDiscount = () => setOpenDisableDiscount(false);



   const [openAddDiscount, setOpenAddDiscount] = useState(false);
  const handleCloseAddDiscount = () => setOpenAddDiscount(false);
  // const handleCloseDisable = () => setOpenDisable(false);

  useEffect(() => {
    WarehouseService.getAllRealWarehouse(getCurrentUserId(), 0)
      .then((response) => {
        if (response.data.success) {
          setWarehouses(response.data.success);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de dépôt");
        }
      })
      .catch((e) => {
        console.log("error in getAllRealWarehouse", e);
      });
    DiscountService.getDeclencheursById(
      getCurrentUserId(),
      localStorage.getItem("idDeclencheur")
    )
      .then((response) => {
        if (response.data.success) {
          console.log("response", response.data.success);
          setAvailableDeclencheurs(response.data.success);
        } else {
          setOpenInfoAlert(true);
          setInfoAlertText("Pas de Déclencheurs");
        }
      })
      .catch((e) => {
        console.log("error in allDiscounts", e);
      });
  }, []);
  const onChangeSelectedWarehouse = (selectedOption) => {
    
    setWarehouseSelectPlaceHolder();
    setListWarehouseId(selectedOption);
    setChoosenWarehouse(true);
  };

  useEffect(() => {
    warehouses &&
      warehouses.map((element) => {
        let exist = false;
        if (allWarehouse.length !== 0) {
          for (let index = 0; index < allWarehouse.length; index++) {
            if (allWarehouse[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }
        if (element?.id !== undefined && exist === false) {
          setAllWarehouse((oldArray) => [
            ...oldArray,
            { value: element.id, label: element.name },
          ]);
        }
        //here
      });
  }, [warehouses]);
  const onChooseWarehouseHandler = (event) => {
    if (choosenWarehouse) {
      let rule = {
        idUser: getCurrentUserId(),
        isActive: 1,
        isDeleted: 0,
        warehouses: listWarehouseId,
      };
      console.log("rule", JSON.stringify(rule));
      DiscountService.allRulesByWarehouse(rule)
        .then((response) => {
          console.log("allDiscounts", response);
          setAllDiscounts([]);
          if (response.data.success) {
            response.data.success.map((element) => {
              let exist = false;
              if (allDiscounts.length !== 0) {
                for (let index = 0; index < allDiscounts.length; index++) {
                  if (allDiscounts[index].value === element?.id) {
                    exist = true;
                    break;
                  }
                }
              }
              if (element?.id !== undefined && exist === false) {
                setAllDiscounts((oldArray) => [
                  ...oldArray,
                  { value: element.id, label: element.libelle },
                ]);
              }
              //here
            });
            setChoosenRulesWarehouses(1);
          } else {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : pas de dépôt");
          }
        })
        .catch((e) => {
          console.log("error in getAllRealWarehouse", e);
        });
    }
  };
 
  const onChangeSelectedDiscount = (selectedOption) => {
    setDiscountSelectPlaceHolder();
    console.log(selectedOption);
    setDiscountId(selectedOption.value);
    setDiscountLabel(selectedOption.label);
  };
  const listRulesWarehouse = () => {
    if (choosenRulesWarehouses === 0) {
      return (
        <div className="col-sm-12">
          <label>
            Vous devez choisir un dépôt et appuiller sur le bouton choisir
          </label>
        </div>
      );
    } else if (choosenRulesWarehouses === 1) {
      return (
        <div className="col-sm-12">
          <div class="row">
            <div className="col-sm-5">
              <label>Priorité</label>
              <br />
              <label>
                {Object.values(availableDeclencheurs?.discounts).length + 1}
              </label>
            </div>
            <div className="col-sm-7">
              <label>Choisir une règle</label>

              <Select
                styles={styles}
                closeMenuOnSelect={true}
                components={animatedComponents}
                defaultValue={selectedOptionDiscount}
                onChange={onChangeSelectedDiscount}
                options={allDiscounts}
                placeholder={discountSelectPlaceHolder}
              />
            </div>
          </div>
        
        </div>
      );
    }
  };
  const handleClickDiscountDisable = async () => {
    try {
      let model = {
        idUser: getCurrentUserId(),
        idDeclencheur: localStorage.getItem("idDeclencheur"),
        idDiscount: discountId,
      };
      const response =
        await DiscountService.updateDeclencheurRemoveDiscountById(model);
      toastr.success(response.data.success);
      handleCloseDisableDiscount();
      window.location.reload(true);
      // console.log("Carte Cadeau disabled successfully");
    } catch (error) {
      console.error("Error disabling Carte Cadeau:", error);
    }
  };


   const handleClickDiscountAdd = async () => {
    try {
      let model = {
        idUser: getCurrentUserId(),
        idDeclencheur: localStorage.getItem("idDeclencheur"),
        idDiscount: discountId,
      };
      const response =
        await DiscountService.updateDeclencheurAddDiscountById(model);
      toastr.success(response.data.success);
      handleCloseAddDiscount();
      window.location.reload(true);
    } catch (error) {
      console.error("Error disabling Carte Cadeau:", error);
    }
  };


  const onChangeEndDate = (event) => {
    setEndDate(event.target.value.concat(":59"));
  };
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };
  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  const handleOpenDiscountDisable = (idDiscount, discountName) => {
    setOpenDisableDiscount(true);
    setDiscountId(idDiscount);
    setDiscountLabel(discountName);
  };
   const handleOpenDiscountAdd = async () => {
    setOpenAddDiscount(true);
  };

    const handleOpenDiscountDate = async () => {
    try {
      let model = {
        idUser: getCurrentUserId(),
        idDeclencheur: localStorage.getItem("idDeclencheur"),
        dateFin: endDate,
      };
      const response =
        await DiscountService.updateDeclencheurDateById(model);
      toastr.success("Date fin modifié avec succées");
      window.location.reload(true);
    } catch (error) {
      console.error("Error disabling Carte Cadeau:", error);
    }
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">Home</li>
                <li class="breadcrumb-item active">Modifier déclencheur</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section class="content">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">Declencheur disponible</h3>

            <div class="card-tools">
              <button
                type="button"
                class="btn btn-tool"
                data-card-widget="collapse"
                title="Collapse"
              >
                <i class="fas fa-minus"></i>
              </button>
            </div>
            <br />
            <br />
            {availableDeclencheurs && (
              <p>
                {availableDeclencheurs.refCC}-{availableDeclencheurs.nameCC}
              </p>
            )}

            {availableDeclencheurs && (
              <p>
                <b>Du</b>{" "}
                {UtilsFormule.formatDate(availableDeclencheurs.startDate)}{" "}
                <b>jusqu'à </b>
                {UtilsFormule.formatDate(availableDeclencheurs.endDate)}
              </p>
            )}
          </div>
          <div class="card-body p-0">
            <table class="table  projects">
              <thead>
                <tr>
                  <th>Priorité</th>

                  <th>Règle </th>

                  <th className="text-center" style={{ width: "12%" }}>
                    Supprimer
                  </th>
                </tr>
              </thead>
              <tbody>
                {availableDeclencheurs &&
                  Object.values(availableDeclencheurs?.discounts).map(
                    (element, i) => (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{element.discount.libelle}</td>

                        <td className="text-center">
                          <button
                            style={{ width: 40 }}
                            className="btn btn-danger btn-sm"
                            onClick={() =>
                              handleOpenDiscountDisable(
                                element.discount?.id,
                                element.discount.libelle
                              )
                            }
                          >
                            <i className="fas fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    )
                  )}
              </tbody>
            </table>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">Ajouter promo à un déclencheur</h3>
            </div>
            <div class="card-body ">
              <div className="form-group">
                <label>Choisir le/ les dépôt</label>
                <div className="input-group">
                  <div className="input-group-prepend" style={{ width: "95%" }}>
                    <Select
                      styles={styles}
                      isMulti
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      defaultValue={selectedOptionWarehouse}
                      onChange={onChangeSelectedWarehouse}
                      options={allWarehouse}
                      placeholder={warehouseSelectPlaceHolder}
                    />
                  </div>
                  <div className=" input-group-append">
                    <button
                      onClick={onChooseWarehouseHandler}
                      type="button"
                      class="btn btn-dark"
                    >
                      <i class="fas  fa-solid fa-arrow-down"></i>
                    </button>
                  </div>
                </div>
              </div>
              <br />
              <div className="row">{listRulesWarehouse()}</div>
            </div>
            <div className="card-footer">
                <button
            style={{ height: "40 px", width: "40 px" }}
            type="button"
            className="btn btn-dark float-right"
              onClick={handleOpenDiscountAdd}
          >
           Ajouter
          </button>
            </div>
          </div>
        </div>
      </section>

      <section className="content ">
        <div className="container-fluid">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">Modifier la date déclencheur</h3>
            </div>
            <div class="card-body ">
              <div className="col-sm-6">
                <div className="form-group">
                  <label htmlFor="inputName">Date fin</label>

                  <TextField
                    style={{ width: "100%" }}
                    className="col-sm-12"
                    variant="outlined"
                    value={endDate}
                    onChange={onChangeEndDate}
                    id="datetime-local"
                    type="datetime-local"
                    defaultValue="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    size="small"
                  />
                </div>
              </div>
            </div>
             <div className="card-footer">
                <button
            style={{ height: "40 px", width: "40 px" }}
            type="button"
            className="btn btn-dark float-right"
              onClick={handleOpenDiscountDate}
          >
           Ajouter
          </button>
            </div>
          </div>
        </div>
      </section>

      <Dialog open={openDisableDiscount} onClose={handleCloseDisableDiscount}>
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Voulez-vous désactiver la promo "{discountLabel}" ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDisableDiscount} color="primary">
            Annuler
          </Button>
          <Button onClick={handleClickDiscountDisable} color="error">
            Confirmer
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openAddDiscount} onClose={handleCloseAddDiscount}>
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Voulez-vous Ajouter la promo "{discountLabel}" au déclencheur?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAddDiscount} color="primary">
            Annuler
          </Button>
          <Button onClick={handleClickDiscountAdd} color="error">
            Confirmer
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="error">
          {infoAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(UpdateDeclencheur);
